export default __webpack_public_path__ + "static/media/include_10@2x.4a28d09f.jpg";